/* tslint:disable:max-classes-per-file */

import { Exception } from '@amzn/ihm-associate-tools-js-lib'

export class UserTypeSelectionRequiredException extends Exception {
    constructor (args) {
        super(args)
    }
}

export class MissingUserTypeException extends Exception {
    constructor (args) {
        super(args)
    }
}

export class InvalidStoreIdException extends Exception {
    constructor (args) {
        super(args)
    }
}

export class IllegalStateException extends Exception {
    constructor (args) {
        super(args)
    }
}
